import { render, staticRenderFns } from "./comp-unibtn.vue?vue&type=template&id=35663e41&"
import script from "./comp-unibtn.vue?vue&type=script&lang=js&"
export * from "./comp-unibtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports